import { PersonStanding, Repeat, ShieldAlert, LineChart } from "lucide-react";
import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const FEATURES = [
  {
    icon: PersonStanding,
    h: "Pose estimation",
    p: "Reads how the body moves through each exercise.",
  },
  {
    icon: Repeat,
    h: "Exercise tracking",
    p: "Follows every repetition against the prescribed protocol.",
  },
  {
    icon: ShieldAlert,
    h: "Compensation detection",
    p: "Flags when the body works around a weak movement.",
  },
  {
    icon: LineChart,
    h: "Recovery intelligence",
    p: "Turns sessions into a recovery trend for clinician and doctor.",
  },
];

const BG_IMG =
  "https://images.unsplash.com/photo-1645005512942-a17817fb7c11?q=85&w=1920&auto=format&fit=crop";

export default function Slide05AI() {
  return (
    <div className="relative">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={BG_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-bone via-bone/90 to-bone/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-bone via-transparent to-bone/60" />
      </div>
      <div className="relative z-10 max-w-3xl">
        <SlideTitle>
          Movement intelligence{" "}
          <em className="italic text-gold">behind every session</em>
        </SlideTitle>
        <div className="mt-10 grid gap-7 sm:grid-cols-2">
          {FEATURES.map((f, i) => (
            <FadeUp key={f.h} delay={0.1 + i * 0.08}>
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-navy shadow-sm">
                <f.icon size={18} strokeWidth={1.8} />
              </div>
              <h3 className="mt-4 text-base font-semibold tracking-tight">
                {f.h}
              </h3>
              <p className="mt-1.5 max-w-[280px] text-sm leading-relaxed text-mut">
                {f.p}
              </p>
            </FadeUp>
          ))}
        </div>
        <SlideConclusion delay={0.45}>
          AI assists. Clinicians decide.
        </SlideConclusion>
      </div>
    </div>
  );
}
